// Imports
import ___CSS_LOADER_API_SOURCEMAP_IMPORT___ from "../node_modules/css-loader/dist/runtime/sourceMaps.js";
import ___CSS_LOADER_API_IMPORT___ from "../node_modules/css-loader/dist/runtime/api.js";
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
___CSS_LOADER_EXPORT___.push([module.id, "@import url(https://fonts.googleapis.com/css2?family=Space+Grotesk:wght@500;600;700&family=Inter:wght@400;500;600;700&family=IBM+Plex+Mono:wght@400;500;600;700&display=swap);"]);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `/* Bloomberg Terminal Global Styles */
/* Supports dark + light mode via data-theme attribute */

/* Space Grotesk = headings/brand, Inter = body/UI text, IBM Plex Mono = numeric data.
   Previously "Goldman Sans" was pulled from fonts.cdnfonts.com — an unofficial mirror
   of Goldman Sachs' actual proprietary corporate typeface, and it never reliably
   loaded, silently falling back to system Arial. Replaced with a real, licensed pairing. */

/* ── Dark Mode (default) ─────────────────────────────────── */
:root,
[data-theme="dark"] {
  /* Consolidated to 3 functional roles: base (page + card, same tone —
     border does the separating), recessed (nested boxes/table headers/
     inputs), and hover (the only tone that still needs to stand out). */
  --bb-bg-primary: #0d0f14;
  --bb-bg-secondary: #0d0f14;
  --bb-bg-tertiary: #171a21;
  --bb-bg-hover: #21252e;
  --bb-bg-input: #171a21;
  --bb-text-primary: #e2e8f0;
  --bb-text-secondary: #94a3b8;
  --bb-text-muted: #64748b;
  --bb-text-inverse: #0a0e17;
  --bb-accent: #ff8c00;
  --bb-accent-light: #ffb347;
  --bb-accent-dim: rgba(255, 140, 0, 0.15);
  --bb-blue: #3b82f6;
  --bb-blue-dim: rgba(59, 130, 246, 0.15);
  --bb-border-primary: #1e293b;
  --bb-border-secondary: #334155;
  --bb-border-accent: rgba(255, 140, 0, 0.3);
  --bb-status-positive-bg: rgba(34, 197, 94, 0.12);
  --bb-status-negative-bg: rgba(239, 68, 68, 0.12);
  --bb-status-warning-bg: rgba(245, 158, 11, 0.12);
  --bb-status-info-bg: rgba(59, 130, 246, 0.12);
  --bb-chart-grid: #1e293b;
  --bb-chart-axis: #475569;
  --bb-chart-tooltip: #171a21;
  --bb-selection: rgba(255, 140, 0, 0.3);
  --bb-scrollbar-track: #0d0f14;
  --bb-scrollbar-thumb: #334155;
  --bb-scrollbar-thumb-hover: #475569;
}

/* ── Light Mode ──────────────────────────────────────────── */
[data-theme="light"] {
  --bb-bg-primary: #ffffff;
  --bb-bg-secondary: #f5f7fa;
  --bb-bg-tertiary: #ebeef3;
  --bb-bg-hover: #e2e7ee;
  --bb-bg-input: #f0f2f5;
  --bb-text-primary: #1a1a2e;
  --bb-text-secondary: #4a5568;
  --bb-text-muted: #718096;
  --bb-text-inverse: #ffffff;
  --bb-accent: #0016e0;
  --bb-accent-light: #3344ff;
  --bb-accent-dim: rgba(0, 22, 224, 0.08);
  --bb-blue: #3b82f6;
  --bb-blue-dim: rgba(59, 130, 246, 0.08);
  --bb-border-primary: #e2e8f0;
  --bb-border-secondary: #cbd5e1;
  --bb-border-accent: rgba(0, 22, 224, 0.25);
  --bb-status-positive-bg: rgba(34, 197, 94, 0.10);
  --bb-status-negative-bg: rgba(239, 68, 68, 0.10);
  --bb-status-warning-bg: rgba(245, 158, 11, 0.10);
  --bb-status-info-bg: rgba(59, 130, 246, 0.10);
  --bb-chart-grid: #e2e8f0;
  --bb-chart-axis: #94a3b8;
  --bb-chart-tooltip: #ffffff;
  --bb-selection: rgba(0, 22, 224, 0.2);
  --bb-scrollbar-track: #f5f7fa;
  --bb-scrollbar-thumb: #cbd5e1;
  --bb-scrollbar-thumb-hover: #94a3b8;
}

/* ── Solid backgrounds (no glassmorphism) ────────────────── */
.MuiPaper-root, .MuiCard-root {
  background: var(--bb-bg-secondary) !important;
  backdrop-filter: none !important;
  -webkit-backdrop-filter: none !important;
  border: 1px solid var(--bb-border-primary) !important;
  border-radius: 6px !important;
  box-shadow: none !important;
}

.MuiPaper-elevation3 {
  background: var(--bb-bg-tertiary) !important;
  backdrop-filter: none !important;
  -webkit-backdrop-filter: none !important;
  box-shadow: none !important;
}

/* Tables */
table {
  background: transparent !important;
  backdrop-filter: none !important;
  -webkit-backdrop-filter: none !important;
  border-radius: 4px !important;
  overflow: hidden !important;
}

/* Buttons */
.MuiButton-root {
  border-radius: 4px !important;
  backdrop-filter: none !important;
  text-transform: none !important;
  font-weight: 600 !important;
  font-size: 0.8rem !important;
}

/* Input fields */
.MuiTextField-root .MuiOutlinedInput-root {
  background: var(--bb-bg-input) !important;
  backdrop-filter: none !important;
  -webkit-backdrop-filter: none !important;
  border-radius: 4px !important;
}

/* Chips */
.MuiChip-root {
  border-radius: 4px !important;
  font-weight: 600 !important;
  font-size: 0.7rem !important;
}

/* Dialog */
.MuiDialog-paper {
  background: var(--bb-bg-secondary) !important;
  backdrop-filter: none !important;
  -webkit-backdrop-filter: none !important;
  border: 1px solid var(--bb-border-secondary) !important;
}

/* Remove glass from Box components */
.MuiBox-root[style*="background"],
.MuiBox-root[style*="bgcolor"] {
  backdrop-filter: none !important;
  -webkit-backdrop-filter: none !important;
}

/* DataGrid */
.MuiDataGrid-root {
  background: var(--bb-bg-secondary) !important;
  backdrop-filter: none !important;
  -webkit-backdrop-filter: none !important;
  border: 1px solid var(--bb-border-primary) !important;
}

.MuiDataGrid-root .MuiDataGrid-columnHeaders {
  background: var(--bb-bg-tertiary) !important;
  border-bottom: 2px solid var(--bb-accent) !important;
}

.MuiDataGrid-root .MuiDataGrid-columnHeaderTitle {
  font-weight: 700 !important;
  font-size: 0.7rem !important;
  letter-spacing: 0.05em !important;
  text-transform: uppercase !important;
  color: var(--bb-accent) !important;
}

.MuiDataGrid-root .MuiDataGrid-cell {
  border-bottom: 1px solid var(--bb-border-primary) !important;
  font-size: 0.8rem !important;
  font-family: "IBM Plex Mono", "Fira Code", monospace !important;
  color: var(--bb-text-primary) !important;
}

.MuiDataGrid-root .MuiDataGrid-row:hover {
  background: var(--bb-bg-hover) !important;
}

.MuiDataGrid-root .MuiDataGrid-footerContainer {
  border-top: 1px solid var(--bb-border-primary) !important;
  background: var(--bb-bg-tertiary) !important;
}

/* Table rows */
.MuiTableRow-root {
  background: transparent !important;
}

.MuiTableRow-root:hover {
  background: var(--bb-bg-hover) !important;
}

/* Scrollbar styling */
*::-webkit-scrollbar {
  width: 6px;
  height: 6px;
}

*::-webkit-scrollbar-track {
  background: var(--bb-scrollbar-track);
}

*::-webkit-scrollbar-thumb {
  background: var(--bb-scrollbar-thumb);
  border-radius: 3px;
}

*::-webkit-scrollbar-thumb:hover {
  background: var(--bb-scrollbar-thumb-hover);
}

/* Selection highlight */
::selection {
  background: var(--bb-selection);
  color: var(--bb-text-primary);
}

/* Recharts tooltip */
.recharts-default-tooltip {
  background: var(--bb-chart-tooltip) !important;
  border: 1px solid var(--bb-border-secondary) !important;
  border-radius: 4px !important;
  color: var(--bb-text-primary) !important;
}

.recharts-tooltip-label {
  color: var(--bb-accent) !important;
  font-weight: 600 !important;
}

/* MUI Autocomplete dropdown */
.MuiAutocomplete-popper .MuiPaper-root {
  background: var(--bb-bg-secondary) !important;
  border: 1px solid var(--bb-border-primary) !important;
}

/* ── Live price tick flashing (SSE) ─────────────────────────────────────── */
/* Hold the colour solid for ~5s after a price change, then fade out over the
   final ~0.5s. Softer alpha than a quick pulse since it lingers. */
@keyframes bb-flash-up {
  0%, 90% { background-color: rgba(34, 197, 94, 0.42); }
  100%    { background-color: rgba(34, 197, 94, 0); }
}
@keyframes bb-flash-down {
  0%, 90% { background-color: rgba(239, 68, 68, 0.42); }
  100%    { background-color: rgba(239, 68, 68, 0); }
}
.bb-flash-up   { animation: bb-flash-up   5.5s ease-out; border-radius: 3px; }
.bb-flash-down { animation: bb-flash-down 5.5s ease-out; border-radius: 3px; }

/* Live connection dot */
@keyframes bb-live-pulse {
  0%, 100% { opacity: 1; }
  50%      { opacity: 0.35; }
}
.bb-live-dot { animation: bb-live-pulse 1.6s ease-in-out infinite; }
`, "",{"version":3,"sources":["webpack://./src/glassmorphism.css"],"names":[],"mappings":"AAAA,qCAAqC;AACrC,wDAAwD;;AAExD;;;2FAG2F;;AAG3F,+DAA+D;AAC/D;;EAEE;;wEAEsE;EACtE,wBAAwB;EACxB,0BAA0B;EAC1B,yBAAyB;EACzB,sBAAsB;EACtB,sBAAsB;EACtB,0BAA0B;EAC1B,4BAA4B;EAC5B,wBAAwB;EACxB,0BAA0B;EAC1B,oBAAoB;EACpB,0BAA0B;EAC1B,wCAAwC;EACxC,kBAAkB;EAClB,uCAAuC;EACvC,4BAA4B;EAC5B,8BAA8B;EAC9B,0CAA0C;EAC1C,gDAAgD;EAChD,gDAAgD;EAChD,gDAAgD;EAChD,6CAA6C;EAC7C,wBAAwB;EACxB,wBAAwB;EACxB,2BAA2B;EAC3B,sCAAsC;EACtC,6BAA6B;EAC7B,6BAA6B;EAC7B,mCAAmC;AACrC;;AAEA,+DAA+D;AAC/D;EACE,wBAAwB;EACxB,0BAA0B;EAC1B,yBAAyB;EACzB,sBAAsB;EACtB,sBAAsB;EACtB,0BAA0B;EAC1B,4BAA4B;EAC5B,wBAAwB;EACxB,0BAA0B;EAC1B,oBAAoB;EACpB,0BAA0B;EAC1B,uCAAuC;EACvC,kBAAkB;EAClB,uCAAuC;EACvC,4BAA4B;EAC5B,8BAA8B;EAC9B,0CAA0C;EAC1C,gDAAgD;EAChD,gDAAgD;EAChD,gDAAgD;EAChD,6CAA6C;EAC7C,wBAAwB;EACxB,wBAAwB;EACxB,2BAA2B;EAC3B,qCAAqC;EACrC,6BAA6B;EAC7B,6BAA6B;EAC7B,mCAAmC;AACrC;;AAEA,+DAA+D;AAC/D;EACE,6CAA6C;EAC7C,gCAAgC;EAChC,wCAAwC;EACxC,qDAAqD;EACrD,6BAA6B;EAC7B,2BAA2B;AAC7B;;AAEA;EACE,4CAA4C;EAC5C,gCAAgC;EAChC,wCAAwC;EACxC,2BAA2B;AAC7B;;AAEA,WAAW;AACX;EACE,kCAAkC;EAClC,gCAAgC;EAChC,wCAAwC;EACxC,6BAA6B;EAC7B,2BAA2B;AAC7B;;AAEA,YAAY;AACZ;EACE,6BAA6B;EAC7B,gCAAgC;EAChC,+BAA+B;EAC/B,2BAA2B;EAC3B,4BAA4B;AAC9B;;AAEA,iBAAiB;AACjB;EACE,yCAAyC;EACzC,gCAAgC;EAChC,wCAAwC;EACxC,6BAA6B;AAC/B;;AAEA,UAAU;AACV;EACE,6BAA6B;EAC7B,2BAA2B;EAC3B,4BAA4B;AAC9B;;AAEA,WAAW;AACX;EACE,6CAA6C;EAC7C,gCAAgC;EAChC,wCAAwC;EACxC,uDAAuD;AACzD;;AAEA,qCAAqC;AACrC;;EAEE,gCAAgC;EAChC,wCAAwC;AAC1C;;AAEA,aAAa;AACb;EACE,6CAA6C;EAC7C,gCAAgC;EAChC,wCAAwC;EACxC,qDAAqD;AACvD;;AAEA;EACE,4CAA4C;EAC5C,oDAAoD;AACtD;;AAEA;EACE,2BAA2B;EAC3B,4BAA4B;EAC5B,iCAAiC;EACjC,oCAAoC;EACpC,kCAAkC;AACpC;;AAEA;EACE,4DAA4D;EAC5D,4BAA4B;EAC5B,+DAA+D;EAC/D,wCAAwC;AAC1C;;AAEA;EACE,yCAAyC;AAC3C;;AAEA;EACE,yDAAyD;EACzD,4CAA4C;AAC9C;;AAEA,eAAe;AACf;EACE,kCAAkC;AACpC;;AAEA;EACE,yCAAyC;AAC3C;;AAEA,sBAAsB;AACtB;EACE,UAAU;EACV,WAAW;AACb;;AAEA;EACE,qCAAqC;AACvC;;AAEA;EACE,qCAAqC;EACrC,kBAAkB;AACpB;;AAEA;EACE,2CAA2C;AAC7C;;AAEA,wBAAwB;AACxB;EACE,+BAA+B;EAC/B,6BAA6B;AAC/B;;AAEA,qBAAqB;AACrB;EACE,8CAA8C;EAC9C,uDAAuD;EACvD,6BAA6B;EAC7B,wCAAwC;AAC1C;;AAEA;EACE,kCAAkC;EAClC,2BAA2B;AAC7B;;AAEA,8BAA8B;AAC9B;EACE,6CAA6C;EAC7C,qDAAqD;AACvD;;AAEA,8EAA8E;AAC9E;mEACmE;AACnE;EACE,UAAU,yCAAyC,EAAE;EACrD,UAAU,sCAAsC,EAAE;AACpD;AACA;EACE,UAAU,yCAAyC,EAAE;EACrD,UAAU,sCAAsC,EAAE;AACpD;AACA,iBAAiB,sCAAsC,EAAE,kBAAkB,EAAE;AAC7E,iBAAiB,sCAAsC,EAAE,kBAAkB,EAAE;;AAE7E,wBAAwB;AACxB;EACE,WAAW,UAAU,EAAE;EACvB,WAAW,aAAa,EAAE;AAC5B;AACA,eAAe,kDAAkD,EAAE","sourcesContent":["/* Bloomberg Terminal Global Styles */\n/* Supports dark + light mode via data-theme attribute */\n\n/* Space Grotesk = headings/brand, Inter = body/UI text, IBM Plex Mono = numeric data.\n   Previously \"Goldman Sans\" was pulled from fonts.cdnfonts.com — an unofficial mirror\n   of Goldman Sachs' actual proprietary corporate typeface, and it never reliably\n   loaded, silently falling back to system Arial. Replaced with a real, licensed pairing. */\n@import url('https://fonts.googleapis.com/css2?family=Space+Grotesk:wght@500;600;700&family=Inter:wght@400;500;600;700&family=IBM+Plex+Mono:wght@400;500;600;700&display=swap');\n\n/* ── Dark Mode (default) ─────────────────────────────────── */\n:root,\n[data-theme=\"dark\"] {\n  /* Consolidated to 3 functional roles: base (page + card, same tone —\n     border does the separating), recessed (nested boxes/table headers/\n     inputs), and hover (the only tone that still needs to stand out). */\n  --bb-bg-primary: #0d0f14;\n  --bb-bg-secondary: #0d0f14;\n  --bb-bg-tertiary: #171a21;\n  --bb-bg-hover: #21252e;\n  --bb-bg-input: #171a21;\n  --bb-text-primary: #e2e8f0;\n  --bb-text-secondary: #94a3b8;\n  --bb-text-muted: #64748b;\n  --bb-text-inverse: #0a0e17;\n  --bb-accent: #ff8c00;\n  --bb-accent-light: #ffb347;\n  --bb-accent-dim: rgba(255, 140, 0, 0.15);\n  --bb-blue: #3b82f6;\n  --bb-blue-dim: rgba(59, 130, 246, 0.15);\n  --bb-border-primary: #1e293b;\n  --bb-border-secondary: #334155;\n  --bb-border-accent: rgba(255, 140, 0, 0.3);\n  --bb-status-positive-bg: rgba(34, 197, 94, 0.12);\n  --bb-status-negative-bg: rgba(239, 68, 68, 0.12);\n  --bb-status-warning-bg: rgba(245, 158, 11, 0.12);\n  --bb-status-info-bg: rgba(59, 130, 246, 0.12);\n  --bb-chart-grid: #1e293b;\n  --bb-chart-axis: #475569;\n  --bb-chart-tooltip: #171a21;\n  --bb-selection: rgba(255, 140, 0, 0.3);\n  --bb-scrollbar-track: #0d0f14;\n  --bb-scrollbar-thumb: #334155;\n  --bb-scrollbar-thumb-hover: #475569;\n}\n\n/* ── Light Mode ──────────────────────────────────────────── */\n[data-theme=\"light\"] {\n  --bb-bg-primary: #ffffff;\n  --bb-bg-secondary: #f5f7fa;\n  --bb-bg-tertiary: #ebeef3;\n  --bb-bg-hover: #e2e7ee;\n  --bb-bg-input: #f0f2f5;\n  --bb-text-primary: #1a1a2e;\n  --bb-text-secondary: #4a5568;\n  --bb-text-muted: #718096;\n  --bb-text-inverse: #ffffff;\n  --bb-accent: #0016e0;\n  --bb-accent-light: #3344ff;\n  --bb-accent-dim: rgba(0, 22, 224, 0.08);\n  --bb-blue: #3b82f6;\n  --bb-blue-dim: rgba(59, 130, 246, 0.08);\n  --bb-border-primary: #e2e8f0;\n  --bb-border-secondary: #cbd5e1;\n  --bb-border-accent: rgba(0, 22, 224, 0.25);\n  --bb-status-positive-bg: rgba(34, 197, 94, 0.10);\n  --bb-status-negative-bg: rgba(239, 68, 68, 0.10);\n  --bb-status-warning-bg: rgba(245, 158, 11, 0.10);\n  --bb-status-info-bg: rgba(59, 130, 246, 0.10);\n  --bb-chart-grid: #e2e8f0;\n  --bb-chart-axis: #94a3b8;\n  --bb-chart-tooltip: #ffffff;\n  --bb-selection: rgba(0, 22, 224, 0.2);\n  --bb-scrollbar-track: #f5f7fa;\n  --bb-scrollbar-thumb: #cbd5e1;\n  --bb-scrollbar-thumb-hover: #94a3b8;\n}\n\n/* ── Solid backgrounds (no glassmorphism) ────────────────── */\n.MuiPaper-root, .MuiCard-root {\n  background: var(--bb-bg-secondary) !important;\n  backdrop-filter: none !important;\n  -webkit-backdrop-filter: none !important;\n  border: 1px solid var(--bb-border-primary) !important;\n  border-radius: 6px !important;\n  box-shadow: none !important;\n}\n\n.MuiPaper-elevation3 {\n  background: var(--bb-bg-tertiary) !important;\n  backdrop-filter: none !important;\n  -webkit-backdrop-filter: none !important;\n  box-shadow: none !important;\n}\n\n/* Tables */\ntable {\n  background: transparent !important;\n  backdrop-filter: none !important;\n  -webkit-backdrop-filter: none !important;\n  border-radius: 4px !important;\n  overflow: hidden !important;\n}\n\n/* Buttons */\n.MuiButton-root {\n  border-radius: 4px !important;\n  backdrop-filter: none !important;\n  text-transform: none !important;\n  font-weight: 600 !important;\n  font-size: 0.8rem !important;\n}\n\n/* Input fields */\n.MuiTextField-root .MuiOutlinedInput-root {\n  background: var(--bb-bg-input) !important;\n  backdrop-filter: none !important;\n  -webkit-backdrop-filter: none !important;\n  border-radius: 4px !important;\n}\n\n/* Chips */\n.MuiChip-root {\n  border-radius: 4px !important;\n  font-weight: 600 !important;\n  font-size: 0.7rem !important;\n}\n\n/* Dialog */\n.MuiDialog-paper {\n  background: var(--bb-bg-secondary) !important;\n  backdrop-filter: none !important;\n  -webkit-backdrop-filter: none !important;\n  border: 1px solid var(--bb-border-secondary) !important;\n}\n\n/* Remove glass from Box components */\n.MuiBox-root[style*=\"background\"],\n.MuiBox-root[style*=\"bgcolor\"] {\n  backdrop-filter: none !important;\n  -webkit-backdrop-filter: none !important;\n}\n\n/* DataGrid */\n.MuiDataGrid-root {\n  background: var(--bb-bg-secondary) !important;\n  backdrop-filter: none !important;\n  -webkit-backdrop-filter: none !important;\n  border: 1px solid var(--bb-border-primary) !important;\n}\n\n.MuiDataGrid-root .MuiDataGrid-columnHeaders {\n  background: var(--bb-bg-tertiary) !important;\n  border-bottom: 2px solid var(--bb-accent) !important;\n}\n\n.MuiDataGrid-root .MuiDataGrid-columnHeaderTitle {\n  font-weight: 700 !important;\n  font-size: 0.7rem !important;\n  letter-spacing: 0.05em !important;\n  text-transform: uppercase !important;\n  color: var(--bb-accent) !important;\n}\n\n.MuiDataGrid-root .MuiDataGrid-cell {\n  border-bottom: 1px solid var(--bb-border-primary) !important;\n  font-size: 0.8rem !important;\n  font-family: \"IBM Plex Mono\", \"Fira Code\", monospace !important;\n  color: var(--bb-text-primary) !important;\n}\n\n.MuiDataGrid-root .MuiDataGrid-row:hover {\n  background: var(--bb-bg-hover) !important;\n}\n\n.MuiDataGrid-root .MuiDataGrid-footerContainer {\n  border-top: 1px solid var(--bb-border-primary) !important;\n  background: var(--bb-bg-tertiary) !important;\n}\n\n/* Table rows */\n.MuiTableRow-root {\n  background: transparent !important;\n}\n\n.MuiTableRow-root:hover {\n  background: var(--bb-bg-hover) !important;\n}\n\n/* Scrollbar styling */\n*::-webkit-scrollbar {\n  width: 6px;\n  height: 6px;\n}\n\n*::-webkit-scrollbar-track {\n  background: var(--bb-scrollbar-track);\n}\n\n*::-webkit-scrollbar-thumb {\n  background: var(--bb-scrollbar-thumb);\n  border-radius: 3px;\n}\n\n*::-webkit-scrollbar-thumb:hover {\n  background: var(--bb-scrollbar-thumb-hover);\n}\n\n/* Selection highlight */\n::selection {\n  background: var(--bb-selection);\n  color: var(--bb-text-primary);\n}\n\n/* Recharts tooltip */\n.recharts-default-tooltip {\n  background: var(--bb-chart-tooltip) !important;\n  border: 1px solid var(--bb-border-secondary) !important;\n  border-radius: 4px !important;\n  color: var(--bb-text-primary) !important;\n}\n\n.recharts-tooltip-label {\n  color: var(--bb-accent) !important;\n  font-weight: 600 !important;\n}\n\n/* MUI Autocomplete dropdown */\n.MuiAutocomplete-popper .MuiPaper-root {\n  background: var(--bb-bg-secondary) !important;\n  border: 1px solid var(--bb-border-primary) !important;\n}\n\n/* ── Live price tick flashing (SSE) ─────────────────────────────────────── */\n/* Hold the colour solid for ~5s after a price change, then fade out over the\n   final ~0.5s. Softer alpha than a quick pulse since it lingers. */\n@keyframes bb-flash-up {\n  0%, 90% { background-color: rgba(34, 197, 94, 0.42); }\n  100%    { background-color: rgba(34, 197, 94, 0); }\n}\n@keyframes bb-flash-down {\n  0%, 90% { background-color: rgba(239, 68, 68, 0.42); }\n  100%    { background-color: rgba(239, 68, 68, 0); }\n}\n.bb-flash-up   { animation: bb-flash-up   5.5s ease-out; border-radius: 3px; }\n.bb-flash-down { animation: bb-flash-down 5.5s ease-out; border-radius: 3px; }\n\n/* Live connection dot */\n@keyframes bb-live-pulse {\n  0%, 100% { opacity: 1; }\n  50%      { opacity: 0.35; }\n}\n.bb-live-dot { animation: bb-live-pulse 1.6s ease-in-out infinite; }\n"],"sourceRoot":""}]);
// Exports
___CSS_LOADER_EXPORT___.locals = {};
export default ___CSS_LOADER_EXPORT___;
